import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren, JSX } from 'react';
import { useEffect } from 'react';
import { registerCustomDSLFields } from '../../features';
export function CoverageDslProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  let t2;
  if ($[1] !== children) {
    t2 = <>{children}</>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp() {
  registerCustomDSLFields();
}